import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import SEO from './../../components/seo';
import Hero from './components/hero';
import CompaniesTicker from './components/companiesTicker';
import Style from './style.module.scss';

const Home = () => {
  const { t } = useTranslation();

  const targetRef = useRef(null);

  return (
    <>
      <SEO pageKey="home" />
      <Hero targetRef={targetRef} />
      <CompaniesTicker />
      <section className={clsx(Style.section)} ref={targetRef}>
        <div className={Style.container}>
          <div className={Style.textWrapper}>
            <h2 className={clsx(Style.heading, Style.contactTitle)}>{t('about')}</h2>
            <p className={Style.paragraph}>{t('homeAbout')}</p>
            <p className={clsx(Style.paragraph, Style.bold)}>{t('homeAboutDesc')}</p>
            <Link to={t('routes.about')} className={Style.btn}>
              {t('moreBtn')}
            </Link>
          </div>

          <div className={Style.imageWrapper}>
            <img src={'./assets/img/home-about.png'} alt={'Hakkımızda'} />
          </div>
        </div>
      </section>

      <section className={clsx(Style.section, Style.nGaming)}>
        <div className={clsx(Style.container)}>
          <div className={Style.imageWrapper}>
            <img src={'./assets/img/home-ngaming-life.png'} alt={t('homeNGamingLife.title')} />
          </div>
          <div className={Style.textWrapper}>
            <h2 className={clsx(Style.heading)}>{t('homeNGamingLife.title')}</h2>
            <p className={Style.paragraph}>{t('homeNGamingLife.desc1')}</p>
            <p className={Style.paragraph}>{t('homeNGamingLife.desc2')}</p>
            <p className={Style.paragraph}>{t('homeNGamingLife.desc3')}</p>
            <p className={Style.paragraph}>{t('homeNGamingLife.desc4')}</p>
            <p className={Style.paragraph}>{t('homeNGamingLife.desc5')}</p>
            <p className={Style.paragraph}>{t('homeNGamingLife.desc6')}</p>
            <p className={Style.paragraph}>{t('homeNGamingLife.desc7')}</p>
            <Link to={t('routes.career')} className={Style.btn}>
              {t('moreBtn')}
            </Link>
          </div>
        </div>
      </section>

      <section className={Style.section}>
        <div className={clsx(Style.container)}>
          <div className={Style.textWrapper}>
            <h2 className={clsx(Style.heading)}>{t('homeContact.title')}</h2>
            <p
              className={clsx(Style.paragraph, Style.customParagraph)}
              dangerouslySetInnerHTML={{ __html: t('homeContact.desc') }}
            />
            <Link to={t('routes.contact')} className={Style.btn}>
              {t('moreBtn')}
            </Link>
          </div>

          <div className={Style.imageWrapper}>
            <img src={'./assets/img/home-contact.png'} alt="nGaming-contact" />
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
